import QCollapseItem from '../collapse/src/collapse-item.vue';


export default QCollapseItem;
